import React, { useState, useEffect, Fragment } from 'react'
import classnames from 'classnames'
import { Title, Row, Col, Input } from '../../../components/Form'
import Button from '../../../components/Button'
import Chip from '../../../components/Chip'
import AddressChip from '../../../components/AddressChip'
import AddressButton from '../../../components/AddressButton'
import Step from '../components/Step'
import AddressModal from './AddressModal'
import TooltipDropoffInfo from './TooltipDropoffInfo'

// const tips = [0, 1, 2, 5, 10]

const dropOffOptions = [
  'Leave with doorman',
  'Deliver to my door',
  'Leave at my door'
]

const DeliveryDetails = props => {
  const {
    isCompleted,
    isActive,
    deliveryTimes,
    selectedDeliveryTime,
    changeSelectedDeliveryTime,
    addresses,
    addressesLoading,
    addressesCached,
    getAddresses,
    createAddress,
    updateAddress,
    completeStep,
    // changeTip,
    selectedTip,
    selectedDropoff,
    changeDropoff,
    changeSelectedAddress,
    selectedAddress,
    onEdit,
    changeNote,
    initialNote
  } = props

  const [showAddressModal, setShowAddressModal] = useState(false)
  const [addressToEdit, setAddressToEdit] = useState(null)
  const [addNote, setAddNote] = useState(!!initialNote)
  const [note, setNote] = useState(initialNote)

  useEffect(() => {
    if (isActive && !addressesLoading && !addressesCached) {
      getAddresses()
    }
  }, [isActive])

  const toggleAddNote = () => {
    setAddNote(!addNote)
  }

  const toggleAddressModal = () => {
    setShowAddressModal(!showAddressModal)
  }

  const onCompleteStep = () => {
    if (addNote && note) {
      changeNote(note)
    }
    completeStep()
  }

  const hasNoAddresses = !addresses.length

  const nextStepIsDisabled =
    !selectedDeliveryTime ||
    !selectedAddress ||
    !selectedDropoff ||
    (addNote && !note) ||
    typeof selectedTip !== 'number'

  return (
    <Fragment>
      <AddressModal
        isOpen={showAddressModal}
        onRequestClose={toggleAddressModal}
        createAddress={createAddress}
        updateAddress={updateAddress}
        initialValues={addressToEdit}
        hasNoAddresses={hasNoAddresses}
      />
      <Step
        step={2}
        title="Delivery Details"
        disabled={isCompleted || !isActive}
        completed={isCompleted}
        active={isActive}
        showAction={isCompleted && !isActive}
        actionLabel="Edit"
        onActionClick={onEdit}>
        <div className="cookunity__delivery_details_form">
          <Title>Delivery Time</Title>
          <div className="chips_container timeslots">
            {deliveryTimes.map(t => (
              <Chip
                className="chip"
                key={t.start}
                selected={t.start === selectedDeliveryTime.start}
                label={t.label}
                onClick={() => changeSelectedDeliveryTime(t)}
              />
            ))}
          </div>

          <Title>Delivery Address</Title>
          <div
            className={classnames('addresses_container', {
              loading: addressesLoading
            })}>
            {addresses.map(address => (
              <AddressChip
                key={address.id}
                selected={address.id === selectedAddress.id}
                label={
                  address.isActive
                    ? 'Primary Delivery & Billing Address'
                    : 'Secondary Delivery Address'
                }
                address={address.label}
                onEdit={() => {
                  setAddressToEdit({ ...address })
                  toggleAddressModal()
                }}
                onClick={() => changeSelectedAddress(address)}
              />
            ))}

            <AddressButton
              onClick={() => {
                setAddressToEdit(null)
                toggleAddressModal()
              }}
              label={hasNoAddresses ? 'Add Address' : 'Add Secondary Address'}
            />
          </div>

          {/* <Title>Tip</Title>
          <div className="chips_container">
            {tips.map(tip => (
              <Chip
                className="chip"
                key={tip}
                selected={tip === selectedTip}
                label={`$${tip}`}
                onClick={() => changeTip(tip)}
              />
            ))}
          </div> */}

          <div
            className="tooltip_delivery_options"
            id="tooltip_delivery_options">
            <Title>Delivery Options</Title>
            <TooltipDropoffInfo container="tooltip_delivery_options" />
          </div>
          <div className="chips_container">
            {dropOffOptions.map((opt, i) => (
              <Chip
                className="chip"
                key={i}
                selected={opt === selectedDropoff}
                label={opt}
                onClick={() => changeDropoff(opt)}
              />
            ))}
          </div>

          <Row>
            <Col>
              <Input
                checked={addNote}
                onClick={toggleAddNote}
                type="checkbox"
                label="Add Note"
              />
            </Col>
          </Row>

          {addNote && (
            <Row>
              <Col>
                <Input
                  type="textarea"
                  value={note}
                  maxLength="200"
                  onChange={e => setNote(e.target.value)}
                />
              </Col>
            </Row>
          )}

          <div className="next_step_row">
            <Button
              dark
              large
              onClick={onCompleteStep}
              disabled={nextStepIsDisabled}>
              Next
            </Button>
          </div>
        </div>
      </Step>
    </Fragment>
  )
}

export default DeliveryDetails



// WEBPACK FOOTER //
// ./src/modules/Checkout/DeliveryDetails/DeliveryDetails.jsx